import React, { useEffect, useState } from "react";
import Chart from "react-google-charts";

interface IProps {
    title: string;
    score: number;
    average: number;
}

const ScoreAverages: React.FunctionComponent<IProps> = (props) => {
    const [data, setData] = useState([] as any);

    const options = {
        title: "",
        chartArea: {
            left: 90,
            top: 0,
            bottom: 30,
            right: 30,
            width: "100%",
            height: "100%",
        },
        bar: {
            width: 16,
        },
        legend: {
            position: "none",
        },
        annotations: {
            alwaysOutside: true,
            textStyle: {
                fontSize: 12,
                auraColor: "none",
                color: "#555",
            },
        },
        hAxis: {
            title: "",
            ticks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            baselineColor: "#e3e3e3",
            gridlines: { color: "#e3e3e3" },
            //baselineColor: '#CCCCCC'
        },
        vAxis: {
            title: "",
            baselineColor: "#e3e3e3",
            gridlines: { color: "#e3e3e3" },
        },
    };

    useEffect(() => {
        setData([
            ["", "", { type: "string", role: "annotation" }, { role: "style" }],
            ["Your Score", props.score, props.score + "", "#306E91"],
            ["Average Score\n(for preset profile)", props.average, props.average + "", "#54B5A6"],
        ]);
    }, [props]);

    return (
        <React.Fragment>
            <h4 className="content-title">{props.title} Score Averages</h4>
            <div id="score-average-chart">
                <Chart
                    className={"m-chart-container"}
                    style={{ minHeight: "150px" }}
                    chartType="BarChart"
                    loader={<div>Loading Chart</div>}
                    data={data}
                    options={options}
                    rootProps={{ "data-testid": "1" }}
                    chartEvents={[
                        {
                            eventName: "ready",
                            callback: ({ chartWrapper, google }) => {
                                window.addEventListener(
                                    "keydown",
                                    (event) => {
                                        if (event.key !== "Escape") return;
                                        event.stopPropagation();
                                        window.showtoolTip();
                                    },
                                    true
                                );
                                var chart = new google.visualization.BarChart(document.getElementById("score-average-chart"));
                                var svg = chart.getContainer().getElementsByTagName("svg");
                                if (svg.length > 0) {
                                    svg[0].setAttribute("aria-label", "Score Average Bar Graph");
                                }
                            },
                        },
                    ]}
                />
            </div>
        </React.Fragment>
    );
};
export default ScoreAverages;
